export default __webpack_public_path__ + "static/media/logout.ebdd7ce2.png";